<template>
    <b-card>
      <b-form-group style="margin-top : 1em;">
        <div v-if="editStatus" >
        <vue-editor  :editorOptions="{ modules: { toolbar: true } }" v-model="reply.content"></vue-editor>
        <b-form-textarea  v-show="false" rows="12" id="content" name="content" v-model="reply.content"
            v-validate="{ required: idValidationReq }" :state="validateState('content')"></b-form-textarea>
          <b-form-invalid-feedback id="content-feedback">
            {{ errors.first('content') }}
          </b-form-invalid-feedback>
        </div>
        <div v-else style="position: relative;">
          <h5>
            <span class="user-profile">
              <img src="../../assets/images/icon_user.png" alt="user profile">
            </span>
            <div class="user-info-area">
              <div class="user-info">
                <span class="reply-name">{{ reply.name }}</span>
                <span class="reply-id">{{ reply.creatorId }}</span>
              </div>
              <span class="reply-date">{{reply.creationDate }}</span>
            </div>
          </h5>
          <div class="comment-box">
            <vue-editor ref="editor" :editorOptions="{ modules: { toolbar: false } }" v-model="reply.content" class="replies"
              :disabled="true">
            </vue-editor>
            <button type="button" class="btn-highlight" :class="{ 'active': reply.highlight }" @click="changeReplyHighlight()"></button> 
          </div>
        </div>
      </b-form-group>
    </b-card>
  </template>
  <script>
  import { VueEditor } from 'vue2-editor';
  
  export default ({
    props: ['param'],
    components: { VueEditor, },
    beforeMount() {
      if (typeof (this.param) !== "string") {
        this.reply = this.param;
      } else { // New Reply Case
        this.editStatus = true;
        this.reply.myScheduleId = this.param;
      }
    },
    mounted() {
      if (this.id !== -1) {
        this.$emit('replyPost');
      }
    },
    data() {
      return {
        reply: {
          id: '',
          myScheduleId: '',
          content: '',
          creatorId: '',
          name: '',
          creationDate: ''
        },
        editStatus: false,
        originData: null,
        blStatusDone : false,
      }
    },
    computed: {
      getcontent() {
        return this.content;
      },
      idValidationReq(){
        return this.blStatusDone
      }
    },
    
    methods: {
      async changeReplyHighlight(){
        this.reply.highlight= !this.reply.highlight
        try {
          axios.post('/chatter/updateMyScheduleHighlightComment/' + this.reply.id, '', {
            params:{
              highlight : this.reply.highlight
            },
            headers: {
              Authorization: accessToken()
            }
          })
        } catch(error) {
          this.showError(error);
        }
      },
      async setValidation(paramStatusDone){
        this.blStatusDone = paramStatusDone;
        if(paramStatusDone){
          this.$validator.validate();
        }
      },
      async validate(){
        let errFields = [];
        this.errors.items.forEach((error) => {
          if(this.$refs[error.field]!=undefined){
            this.$refs[error.field].focus();
          }
          errFields.push(error.field);
        });
        return this.errFields;
      },
      validateState(ref) {
        if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
          return !this.errors.has(ref);
        }
        return null;
      },
      async replyPost() {
        let result = await this.$validator.validate();
        if (!result) return Promise.reject(new Error('400'));
        await this.update();
      },
      async update(){
        if(this.reply.content.replaceAll('<p>','').replaceAll('</p>','').replaceAll('<br>','').trim()=='')return;
        let user = this.$store.getters['auth/currentUser'];
        let data = new FormData();
        data.append('myScheduleId',this.param);
        data.append('content', this.reply.content);
        data.append('creatorId', user)

        await axios.post('chatter/addMyScheduleComment',
          data,
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'multipart/form-data',
              Authorization: accessToken()
            }
          });
        this.$emit('reload-replies');
        this.reply.content = '';
      }
    }
  })
  </script>
  <style>
  .hide-toolbar .ql-toolbar {
    display: none;
  }
  
  .replies .ql-editor {
    min-height: 60px !important;
    padding : 1em !important;
  }
  
  /* import font */
  @import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');
  
  h5 {
    display: flex;
    gap: 0 1.333rem;
    margin-bottom: 0.7rem !important;
  }
  .user-profile {
    position: relative;
    display: inline-block;
    flex-shrink: 0;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
  }
  .user-profile img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: auto;
    object-fit: cover;
  }
  .user-info {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0.266rem;
  }
  .reply-name {
    position: relative;
    padding-right: 0.666rem;
    margin-right: 0.666rem;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 16px;
    font-weight: 700;
    line-height: 150%;
    white-space: nowrap;
  }
  .reply-name::after {
    content: '';
    display: block;
    position: absolute;
    top: 3px;
    right: 0;
    width: 1px;
    height: 14px;
    background-color: #2E2E38;
  }
  .reply-id {
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 16px;
    font-weight: 700;
    line-height: 150%;
  }
  .reply-date {
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
  }
  .replies {
    margin-left: 4.666rem;
  }
  .replies .ql-container.ql-snow {
    border: none;
    border-radius: 0px 20px 20px 20px;
    background-color:#F6F6FA;
  }
  .replies .ql-editor {
    padding: 0.933rem 3.333rem 0.933rem 1.333rem !important;
  }
  .comment-reply .ql-editor {
    max-height: 16.133rem;
  }
  .comment-box {
    position: relative;
  }
  .btn-highlight {
    position: absolute;
    top: 0.933rem;
    right: 1rem;
    display: block;
    width: 20px;
    height: 20px;
    border: none;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.4902 7.06219L10.3799 2.48726C10.231 2.1644 9.77215 2.1644 9.62323 2.48726L7.51302 7.06219C7.45232 7.19378 7.32762 7.28438 7.18372 7.30144L2.18061 7.89464C1.82753 7.9365 1.68574 8.37291 1.94678 8.61432L5.6457 12.035C5.75209 12.1334 5.79972 12.28 5.77148 12.4221L4.7896 17.3636C4.72031 17.7124 5.09154 17.9821 5.4018 17.8084L9.79807 15.3476C9.92451 15.2768 10.0787 15.2768 10.2051 15.3476L14.6014 17.8084C14.9116 17.9821 15.2829 17.7124 15.2136 17.3636L14.2317 12.4221C14.2034 12.28 14.2511 12.1334 14.3575 12.035L18.0564 8.61432C18.3174 8.37291 18.1756 7.9365 17.8226 7.89464L12.8194 7.30144C12.6755 7.28438 12.5508 7.19378 12.4902 7.06219Z" stroke="%23C4C4CD" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>') transparent center no-repeat;
  }
  .btn-highlight.active {
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.4902 7.06219L10.3799 2.48726C10.231 2.1644 9.77215 2.1644 9.62323 2.48726L7.51302 7.06219C7.45232 7.19378 7.32762 7.28438 7.18372 7.30144L2.18061 7.89464C1.82753 7.9365 1.68574 8.37291 1.94678 8.61432L5.6457 12.035C5.75209 12.1334 5.79972 12.28 5.77148 12.4221L4.7896 17.3636C4.72031 17.7124 5.09154 17.9821 5.4018 17.8084L9.79807 15.3476C9.92451 15.2768 10.0787 15.2768 10.2051 15.3476L14.6014 17.8084C14.9116 17.9821 15.2829 17.7124 15.2136 17.3636L14.2317 12.4221C14.2034 12.28 14.2511 12.1334 14.3575 12.035L18.0564 8.61432C18.3174 8.37291 18.1756 7.9365 17.8226 7.89464L12.8194 7.30144C12.6755 7.28438 12.5508 7.19378 12.4902 7.06219Z" fill="%23747480" stroke="%23747480" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>') transparent center no-repeat;
  }
  /* 마우스 오버 */
  .btn-highlight:hover {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.4882 7.06219L10.378 2.48726C10.2291 2.1644 9.7702 2.1644 9.62127 2.48726L7.51106 7.06219C7.45037 7.19378 7.32567 7.28438 7.18177 7.30144L2.17866 7.89464C1.82558 7.9365 1.68378 8.37291 1.94482 8.61432L5.64375 12.035C5.75014 12.1334 5.79777 12.28 5.76953 12.4221L4.78765 17.3636C4.71836 17.7124 5.08959 17.9821 5.39984 17.8084L9.79611 15.3476C9.92256 15.2768 10.0767 15.2768 10.2031 15.3476L14.5994 17.8084C14.9097 17.9821 15.2809 17.7124 15.2116 17.3636L14.2297 12.4221C14.2015 12.28 14.2491 12.1334 14.3555 12.035L18.0544 8.61432C18.3155 8.37291 18.1737 7.9365 17.8206 7.89464L12.8175 7.30144C12.6736 7.28438 12.5489 7.19378 12.4882 7.06219Z" stroke="%232E2E38" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  }
  .btn-highlight.active:hover {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.4882 7.06219L10.378 2.48726C10.2291 2.1644 9.7702 2.1644 9.62127 2.48726L7.51106 7.06219C7.45037 7.19378 7.32567 7.28438 7.18177 7.30144L2.17866 7.89464C1.82558 7.9365 1.68378 8.37291 1.94482 8.61432L5.64375 12.035C5.75014 12.1334 5.79777 12.28 5.76953 12.4221L4.78765 17.3636C4.71836 17.7124 5.08959 17.9821 5.39984 17.8084L9.79611 15.3476C9.92256 15.2768 10.0767 15.2768 10.2031 15.3476L14.5994 17.8084C14.9097 17.9821 15.2809 17.7124 15.2116 17.3636L14.2297 12.4221C14.2015 12.28 14.2491 12.1334 14.3555 12.035L18.0544 8.61432C18.3155 8.37291 18.1737 7.9365 17.8206 7.89464L12.8175 7.30144C12.6736 7.28438 12.5489 7.19378 12.4882 7.06219Z" fill="%232E2E38" stroke="%232E2E38" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  }
  </style>